<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>ダイスバトル設定</title-bar>
    <b-tabs class="setting">
      <b-tab title="アイコン">
        <b-form-group id="normal-icon" label="通常アイコン">
          <icon-dropdown :list="iconList" v-model="form.icon.normal"
            width="60px" height="60px"
          />
        </b-form-group>
      </b-tab>
      <b-tab title="イベント">
        <b-form-group id="died" label="戦闘不能時">
          <b-form-select v-model="form.event.died" 
            :options="performance" />
        </b-form-group>
        <b-form-group id="normalAttack" label="通常攻撃時">
          <b-form-select v-model="form.event.normalAttack" 
            :options="performance" />
        </b-form-group>
        <b-form-group id="falter" label="怯み時">
          <b-form-select v-model="form.event.falter" 
            :options="performance" />
        </b-form-group>
      </b-tab>
      <b-tab title="演出">
        <b-card v-for="(p,k) in form.performance" :key="k" 
          :title="p.name">
          <b-form-group label="名前" label-cols="3">
            <b-form-input v-model="p.name" debounce="500" />
          </b-form-group>
          <b-form-group label="発言１" label-cols="3">
            <div class="remark">
              <icon-dropdown :list="iconList" v-model="p.icon1"
                width="60px" height="60px"
              />
              <remark-editor class="editor" v-model="p.remark1"
                :danger="1000" :warn="800"
              ></remark-editor>
            </div>
          </b-form-group>
          <b-form-group label="カットイン" label-cols="3">
            <b-form-input placeholder="" v-model="p.cutin" debounce="500" />
            <b-img width="250px" height="75px" :src="p.cutin" fluid />
          </b-form-group>
          <b-form-group label="発言２" class="remark" label-cols="3">
            <div class="remark">
              <icon-dropdown :list="iconList" v-model="p.icon2"
                width="60px" height="60px"
              />
              <remark-editor class="editor" v-model="p.remark2"
                :danger="1000" :warn="800"
              ></remark-editor>
            </div>
          </b-form-group>
        </b-card>
        <b-button @click="addPerformance">
          <font-awesome-icon icon="plus-square" class="fa-1x p-0" />追加
        </b-button>
        {{ performance.length }} / {{ maxPerformance }}
      </b-tab>
    </b-tabs>
    <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
    <response-message :value="postMessage" />
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import IconDropdown from '@/components/IconDropdown'
import RemarkEditor from '@/components/RemarkEditor'
import _ from 'lodash'
import ResponseMessage from '@/components/ResponseMessage'
export default {
  components: {
    WhitePage,
    TitleBar,
    IconDropdown,
    RemarkEditor,
    ResponseMessage
  },
  computed: {
    performance () {
      return _.map(_.keys(this.form.performance), 
        k=>{ return { value:k, text:this.form.performance[k].name } })
    }
  },
  data () {
    return {
      form: {
        icon: {},
        event: {},
        performance: {}
      },
      maxPerformance: 0,
      iconList: [],
      loading: false,
      postMessage: {},
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.form.icon = response.icon
      this.form.event = response.event
      this.form.performance = response.performance
      this.iconList = response.iconList
      this.maxPerformance = response.maxPerformance
    },
    onSubmit () {
      this.$store.dispatch('setDiceBattle', this.form)
        .then((response)=>{
          if(response.error === '200 OK'){
            this.setData(response)
          }
          this.postMessage = response
        })
    },
    addPerformance () {
      if(this.performance.length < this.maxPerformance){
        let id = '@'+_.uniqueId()
        this.$set(this.form.performance,id,{
          name: `演出${_.keys(this.form.performance).length+1}`,
          remark1: null, remark2: null,
          icon1: null, icon2:null,
          cutin: null
        })
      }
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getDiceBattle')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  // mounted () {
  //   phina.global.app.currentScene.exit('MainScene')
  // }
}
</script>

<style lang="scss" scoped>
.remark {
  display: flex;
}
.editor {
  width: calc(100% - 60px);
}
.setting {
  margin-bottom: 30px;
}
</style>
